/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.headerDesktop", {
        options: {},

        _create: function () {
            this.wrap = this.element;

            this._iniVars();

            this._createLine();

            this._toShowSubMenu(this.activeMainMenu, 0);

            this._iniMainMenu();
            
            this._iniSubMenu();

            this._iniMegaMenu();

            this._iniSideMenu();

            this._showIconsLabel();
            
            this.wrap.find('.btn--close').on("click", ()=>{
                this._hideMegaMenu();
            })
        },

        _iniVars() {
            // delays
            this.delayMainMenuReset = 1000;
            this.delaySubMenuReset = 1000;
            this.delayShowSubMenu = 200;
            this.delayMegaMenuReset = 1000;
            this.delaySideMenuReset = 1000;
            this.delayShowSideMenu = 200;
            this.delayShowMegaMenu = 500;

            //hover timers
            this.mainMenuTimer = 0;
            this.subMenuTimer = 0;
            this.megaMenuTimer = 0;
            this.showMegaMenuTimer = 0;
            this.sideMenuTimer = 0;

            this.menuItems = this.wrap.find(".header__menu__item");
            this.activeMainMenu = this.wrap.find(".header__menu .active a");

            this.subMenu = this.wrap.find(".header__sub");
            this.subMenuItems = this.subMenu.find(".header__sub__item");
            this.activeSubMenu = this.subMenu.find(".active a");
            this.subLine = null

            this.megaMenu = this.wrap.find(".header__mega");
            this.megaMenuItems = this.megaMenu.find(".header__mega__items");
            this.megaMenuLinks = this.megaMenu.find(".header__mega__col .header__mega__item");
            
        },

        _createLine(){
            this.subLine = $('<div class="header__sub__line"></div>').appendTo(this.subMenu)
        },

        _moveLine(){
            var actSubMenu = this.subMenu.find("li.active:visible")
            if(actSubMenu.length){
                this.subLine.css({
                    'transform':`translateX(${actSubMenu.offset().left}px)`,
                    "width": actSubMenu.outerWidth()
                })
            } else {
                this.subLine.css({
                    "width": 0
                })
            }
        },

        /* #region main menu and submenu */
        _iniMainMenu() {
            this.menuItems
                .on("mouseover focus", (e) => {
                    var item = $(e.target);

                    api.accessibilities.ARIA_toggleContent(this.menuItems, false);
                    api.accessibilities.ARIA_toggleContent(item, true);

                    clearTimeout(this.mainMenuTimer);
                    clearTimeout(this.megaMenuTimer);

                    this._hideMegaMenu();

                    

                    if(item.attr("aria-haspopup")==="true"){
                     
                        this._setActiveMainMenu(item);                        

                        this._toShowSubMenu(item, this.delayShowSubMenu);

                        this._resetSubMenu()
                        
                        this._moveLine()

                    } else {                      
                        $(".header__sub__items", this.subMenu).removeClass('active').hide();

                    }
                    

                })
                .on("mouseout", (e) => {
                    var item = $(e.target);

                    this._toResetMainMenu();
                    this._toHideMegaMenu()
                });
            
        },

        _removeActiveMainMenu() {
            this.menuItems.parent().removeClass("active");
        },

        _setActiveMainMenu(lnk) {            
            this._removeActiveMainMenu();
            lnk.parent().addClass("active");
        },

        _toResetMainMenu() {
            this.mainMenuTimer = setTimeout(() => {
                this._resetMainMenu();
            }, this.delayMainMenuReset);
        },

        _resetMainMenu() {
            this._setActiveMainMenu(this.activeMainMenu);
            this._toShowSubMenu(this.activeMainMenu, 0);
            api.accessibilities.ARIA_toggleContent(this.menuItems, false);
            api.accessibilities.ARIA_toggleContent(this.activeMainMenu, true);
        },

        _toShowSubMenu(item, delay) {
           
            if (item.attr("aria-haspopup")==="true") {
                var activeSubMenu = $(`#${item.attr("aria-controls")}`);            

                this.mainMenuTimer = setTimeout(() => {
                    this._showSubMenu(activeSubMenu);
                }, delay);
            }
        },

        _showSubMenu(activeSubMenu) {
            $(".header__sub__items", this.subMenu).not(activeSubMenu).removeClass('active').hide();
            activeSubMenu.show();
            
            setTimeout(()=>{             
                activeSubMenu.addClass('active')
                setTimeout(()=>{
                    this._moveLine()
                },100)
            },10)
        },
        
        /* #endregion */

        /* #region submenu */
        _iniSubMenu(){
            this.subMenu
                .on("mouseover focus", (e) => {
                    var item = $(e.target)

                    // if (item.attr("aria-haspopup")==="true") {
                    //     e.preventDefault()
                    // }

                    clearTimeout(this.mainMenuTimer);
                    clearTimeout(this.megaMenuTimer);
                    clearTimeout(this.subMenuTimer);
                    
                })
                .on("mouseout", (e) => {
                    this._toResetMainMenu();
                    this._toResetSubMenu()
                    this._toHideMegaMenu()
                });
        },

        _setActiveSubMenu(lnk) {  
            this._removeActiveSubMenu();
            this._addInactiveSubMenu(lnk);
            lnk.parent().removeClass("inactive").addClass("active");
            this._moveLine();
        },        

        _removeActiveSubMenu() {
            this.subMenuItems.parent().removeClass("active");
            this._moveLine();
        },

        _addInactiveSubMenu(lnk){           
            this.subMenuItems.not(lnk).parent().addClass("inactive");

        },

        _toResetSubMenu() {
            this.subMenuTimer = setTimeout(() => {
                this._resetSubMenu();
            }, this.delaySubMenuReset);
        },

        _resetSubMenu(){
            this._setActiveSubMenu(this.activeSubMenu);
            this.subMenuItems.parent().removeClass("inactive");
        },        
        /* #endregion */

        /* #region megaMenu */
        _iniMegaMenu() {
            this.subMenuItems
                .on("mouseover focus", (e) => {
                    var item = $(e.target);

                    
                    clearTimeout(this.mainMenuTimer);
                    clearTimeout(this.megaMenuTimer);
                    clearTimeout(this.subMenuTimer);
                    clearTimeout(this.showMegaMenuTimer);
                    
                    api.accessibilities.ARIA_toggleContent(this.subMenuItems, false);
                    api.accessibilities.ARIA_toggleContent(item, true);

                    this._subRemoveActive();

                    this._hideSideMenu();

                    this._setActiveSubMenu(item);

                    this._toShowMegaMenu(item);

                })
                .on("mouseout", (e) => {
                    var item = $(e.target);
                });

            
            this.megaMenu
                .on("mouseover", (e) => {
                    clearTimeout(this.mainMenuTimer);
                    clearTimeout(this.megaMenuTimer);
                    clearTimeout(this.subMenuTimer);
                    clearTimeout(this.showMegaMenuTimer);
                })
                .on("mouseout", (e) => {
                    this._toHideMegaMenu()
                })

            
        },        

        _toShowMegaMenu(item, delay) {
            
            if (item.attr("aria-haspopup")==="true") {
                var activeMegaMenu = $(`#${item.attr("aria-controls")}`);

                if(activeMegaMenu.length){

                    this.showMegaMenuTimer = setTimeout(() => {                        
                       
                        this._showMegaMenu(activeMegaMenu);

                    }, this.delayShowMegaMenu);

                } else {
                    this._hideMegaMenu()
                }
            }
        },

        _showMegaMenu(activeMegaMenu) {
            if(this.megaMenu.hasClass('active')){
                this.megaMenu.show()
                this.wrap.addClass("mega-menu-opened")
                this._showMegaMenuItem(activeMegaMenu)
                $('html, body').addClass('noscroll-desktops')
            } else {
                this._showMegaMenuItem(activeMegaMenu)
                this.megaMenu.slideDown(250, 'linear', ()=>{
                    this.megaMenu.addClass("active")
                    this.wrap.addClass("mega-menu-opened")
                    $('html, body').addClass('noscroll-desktops')
                });
            }
        },

        _showMegaMenuItem(activeMegaMenu){
            this._hideMegaMenuItems(activeMegaMenu)
            activeMegaMenu.show();
        },

        _hideMegaMenuItems(activeMegaMenu){
            this.megaMenuItems.not(activeMegaMenu).hide();
            $('html, body').removeClass('noscroll-desktops')
        },

        _toHideMegaMenu() {
            
            clearTimeout(this.showMegaMenuTimer);
            this.megaMenuTimer = setTimeout(() => {
                this._hideMegaMenu();
            }, this.delayMegaMenuReset);
        },

        _hideMegaMenu(){
            this._hideMegaMenuItems()
            this.megaMenu.removeClass("active").hide()
            this.wrap.removeClass("mega-menu-opened")
            api.accessibilities.ARIA_toggleContent(this.subMenuItems, false);
        },
        /* #endregion */
        
        /* #region megaMenu */
        _iniSideMenu(){
            this.megaMenuLinks
                .on("mouseover", (e) => {
                    var item = $(e.target);

                    clearTimeout(this.mainMenuTimer);
                    clearTimeout(this.megaMenuTimer);
                    clearTimeout(this.subMenuTimer);
                    clearTimeout(this.sideMenuTimer);

                    this._subAddActive(item)

                    this._toShowSideMenu(item, this.delayShowSideMenu)

                })
                .on("mouseout", (e) => {
                    var item = $(e.target);

                });
        },

        _subAddActive(item){
            this._subRemoveActive()
            var parent = item.parents('.header__mega__col')
            if(parent.length){
                item.addClass('active')
            }
        },

        _subRemoveActive(item){
            this.megaMenu.find('.header__mega__col .active').removeClass('active')
        },

        _toShowSideMenu(item, delay) {
            if (item.attr("aria-haspopup")==="true") {
                var activeSideMenu = $(`#${item.attr("aria-controls")}`);

                this.sideMenuTimer = setTimeout(() => {
                    this._showSideMenu(activeSideMenu);
                }, delay);
            } else {
                
                this._hideSideMenu()
            }
        },

        _showSideMenu(activeSideMenu){
            this._hideSideMenu()
            activeSideMenu.parents(".header__mega__side").addClass("active")
            activeSideMenu.show()
        },

        _hideSideMenu(){
            $(".header__mega__side__item", this.megaMenu).hide()
            $(".header__mega__side", this.megaMenu).removeClass("active")
        },

        _showIconsLabel(){
            var items =  $(".header__tools__anim", this.wrap);           

            items.each(function(){
                $(this).mouseenter(function(){
                    $(this).addClass('expand'); 
                    $(this).find('a:first-child').addClass('blue')
                })

                $(this).mouseleave(function(){
                    $(this).removeClass('expand');
                    $(this).find('a:first-child').removeClass('blue')
                })
            })
        }
        /* #endregion */
        
    });
})(jQuery);
